import { PackageService } from './package-service.model';
import { SelectorBoatDTO } from './dtos/selector-boat-DTO';

export class ServicePackageOrder {
  id: number;
  packageService: PackageService;
  boat: SelectorBoatDTO;
  validityStartDate: Date;
  validityEndDate: Date;
  value: number;
  discount: number;
  observations: string;
  createdAt: Date;
  updatedAt: Date;
  active: boolean;

  constructor() {
    this.packageService = new PackageService();
    this.boat = new SelectorBoatDTO();
    this.value = 0;
    this.discount = 0;
    this.observations = '';
    this.active = true;
  }
}
